import './App.css';
import PortfolioCard from "./components/PortfolioCard.js";

function App() {
  return (
    <PortfolioCard/>
  );
}

export default App;
